var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKlarnaPay = function SvgKlarnaPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#klarnaPay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#FFB3C7",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#klarnaPay_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB3C7",
    d: "M28.116 1.672H3.889a2.88 2.88 0 0 0-2.88 2.88v10.9a2.88 2.88 0 0 0 2.88 2.878h24.227a2.88 2.88 0 0 0 2.879-2.879v-10.9a2.88 2.88 0 0 0-2.88-2.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    fillRule: "evenodd",
    d: "M28.187 11.449c-.392 0-.71.32-.71.717s.318.716.71.716c.393 0 .71-.32.71-.716a.713.713 0 0 0-.71-.717m-2.337-.554c0-.542-.459-.981-1.025-.981s-1.026.439-1.026.98c0 .543.46.982 1.026.982s1.025-.44 1.025-.981m.004-1.907h1.132v3.814h-1.132v-.244c-.32.22-.706.35-1.122.35a2.004 2.004 0 0 1-1.994-2.013c0-1.112.893-2.013 1.994-2.013.416 0 .803.13 1.122.35zm-9.057.496v-.496H15.64v3.814h1.16V11.02c0-.6.646-.924 1.094-.924h.014V8.989c-.46 0-.883.198-1.11.496m-2.886 1.41c0-.541-.46-.98-1.025-.98-.567 0-1.026.439-1.026.98 0 .543.46.982 1.026.982s1.025-.44 1.025-.981m.004-1.906h1.132v3.814h-1.132v-.244c-.32.22-.706.35-1.122.35a2.004 2.004 0 0 1-1.995-2.013c0-1.112.893-2.013 1.995-2.013.416 0 .802.13 1.122.35zm6.812-.103c-.452 0-.88.142-1.166.532v-.43h-1.127v3.815h1.14v-2.005c0-.58.386-.864.85-.864.498 0 .784.3.784.857v2.012h1.13v-2.426c0-.887-.7-1.491-1.611-1.491M9.15 12.802h1.184V7.288H9.15zm-5.204.001h1.255V7.287H3.946zm4.387-5.516a4.4 4.4 0 0 1-1.283 3.13l1.734 2.387h-1.55L5.352 10.21l.486-.368a3.18 3.18 0 0 0 1.269-2.556z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "klarnaPay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "klarnaPay_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1.661h30V18.34H1z"
  })))));
};
export default SvgKlarnaPay;